<template>
  <Popover v-if="initialMetadata?.models?.message_texts" v-slot="{ open }">
    <Float auto-placement portal :offset="10">
      <PopoverButton
        :class="{
          'text-opacity-90': !open,
          'animate-pulse cursor-wait': isLoading
        }"
        class="bg-surface-raised rounded border px-2 py-1 leading-none"
      >
        <FontAwesomeIcon :icon="['fal', 'signature']" />
      </PopoverButton>
      <PopoverPanel
        v-slot="{ close }"
        class="bg-surface-raised z-10 flex w-96 flex-row gap-4 rounded-lg border p-4 px-4 shadow-xl"
      >
        <button
          class="bg-primary text-contrast-primary flex-1 rounded px-2 py-1"
          @click="fetchSignatureFormated('user', close)"
        >
          {{ auth.full_name }}
        </button>
        <button
          class="bg-primary text-contrast-primary flex-1 rounded px-2 py-1"
          @click="fetchSignatureFormated('funeralHome', close)"
        >
          {{ $t('attributes.funeralHome') }}
        </button>
      </PopoverPanel>
    </Float>
  </Popover>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { Float } from '@headlessui-float/vue'

export default {
  name: 'SignaturePopover',
  components: { Float, Popover, PopoverPanel, FontAwesomeIcon, PopoverButton },
  props: {
    modelType: {
      type: String,
      required: false,
      default: null
    },
    modelId: {
      type: String,
      required: false,
      default: null
    },
    from: {
      type: String,
      required: false,
      default: null
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['update-signature'],
  data() {
    return {
      localLoading: false
    }
  },
  computed: {
    ...mapGetters({
      initialMetadata: 'metadata/getInitialMetadata',
      auth: 'auth/getAuth'
    }),
    // True while a parent auto-fill or a manual quill fetch is in flight.
    isLoading() {
      return this.loading || this.localLoading
    }
  },
  methods: {
    ...mapActions({
      processFetchSignatureFormatedAction: 'user/fetchSignatureFormated'
    }),
    fetchSignatureFormated(value, close) {
      const payload = {
        id: this.auth.id,
        model_type: this.modelType ?? null,
        model_id: this.modelId ?? null,
        type: value
      }

      if (value === 'funeralHome' && !this.modelId && !this.modelType) {
        payload.from = this.from.id
      }

      this.localLoading = true
      this.processFetchSignatureFormatedAction(payload)
        .then((response) => {
          this.$emit('update-signature', response.text)
        })
        .finally(() => {
          this.localLoading = false
        })
      close()
    }
  }
}
</script>
